// eslint-disable-next-line no-unused-vars
const sendHttpRequest = (method, url, data) => {
    return fetch(url, {
        method: method,
        headers: data ? { 'Content-Type': 'application/json' } : {},
        mode: 'cors'
    }).then(response => {
        if (response.status >= 400) {
            return response.json().then(errResData => {
                const error = new Error('Something went wrong');
                error.data = errResData;
                throw error;
            })
        }
        return response.json();
    });
};

export const actions = {
    getData(url) {
        return sendHttpRequest('GET', url);
    },
    sendData(url) {
        sendHttpRequest('POST', url, {
            email: 'lintona@test.test'
        })
        .then(responseData => {
            console.log(responseData);
        })
        .catch(err => {
            console.log(err);
        })
    },
}

export default {
    actions,
}